import { useAtom } from "jotai";
import Image from "next/legacy/image";
import { CloseLine } from "@teamsparta/design-system";

import { mktOrientationModalAtom } from "../../../../states/orientation";
import OutsideClickedWrapper from "@/components/atoms/OutsideClickedWrapper";
import Cta from "@/components/atoms/Cta/Cta";

import * as S from "./MktLandingPageOrientationModalOrganism.style";

import modalImg from "public/images/landing/orientation/mkt_otModal.png";

const MktLandingPageOrientationModalOrganism = () => {
  const [modal, setModal] = useAtom(mktOrientationModalAtom);

  return (
    <>
      {modal && (
        <S.ModalBackground>
          <OutsideClickedWrapper setState={setModal}>
            <S.Modal>
              <Image
                src={modalImg}
                layout="fill"
                objectFit="contain"
                alt={"modal-img"}
                quality={100}
              />
              <S.ModalClose onClick={() => setModal(false)}>
                <S.DesktopCloseImg>
                  <CloseLine size={20} />
                </S.DesktopCloseImg>
                <S.MobileCloseImg>
                  <CloseLine size={16} />
                </S.MobileCloseImg>
              </S.ModalClose>
              <S.Cta>
                <Cta onClick={() => window.open(" https://bit.ly/3Ltl4Nu")}>
                  참가 신청하기
                </Cta>
              </S.Cta>
            </S.Modal>
          </OutsideClickedWrapper>
        </S.ModalBackground>
      )}
    </>
  );
};

export default MktLandingPageOrientationModalOrganism;
